import colors from "./Colours";
import Colors from "./Colours";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: Colors.buttonBGColor,
    },
    secondary: {
      main: "#DC004E",
    },
    background: {
      //default: "#fff",
    },
    text: {
      primary: "#000",
      secondary: "#000",
      disabled: "#84818A",
    },
    footer: {
      background: Colors.background2,
      bottomBar: Colors.greyBackground,
      titleColor: Colors.redText,
      captionColor: Colors.mutedText,
    },
  } as any,

  typography: {
    fontFamily: [
      "Open Sans",
      "Poppins",
      "Arial",
      "Helvetica",
      "sans-serif",
      "Inter",
    ].join(","),
    h1: {
      fontSize: "2.5rem",
      fontWeight: 600,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 500,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 500,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 500,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 500,
      secondaryText: {
        color: "rgba(89, 89, 89, 1)",
      },
    },
    subtitle1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
    button: {
      fontSize: "1rem",
      fontWeight: 500,
      textTransform: "none",
    },
    caption: {
      fontSize: "12px",
      fontWeight: 400,
      color: Colors.greyTextColor,
    },
  },
  components: {
    MuiPopover: {
      styleOverrides: {
        root: {
          "&.MuiPopover-root": {
            position: "absolute",
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          "@media (min-width: 600px)": {
            paddingLeft: "48.8px",
            paddingRight: "48.8px",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          padding: "10px",
          width: "100%",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          ".MuiPagination-ul": {
            gap: "12px",

            "& .MuiPaginationItem-root": {
              fontFamily: "Poppins, sans-serif",
              borderRadius: "4px",
              border: "1px solid #EEEEEE",
              background: "#F5F5F5",
              color: "#2D2D43",
              minWidth: "25px",
              height: "24px",
              paddingY: "6px",
              margin: "0px",

              "&.Mui-selected": {
                color: "white",
                background: colors.primaryButtonOrange,
                border: `1px solid ${colors.primaryButtonOrange}`,
              },
              "&:hover": {
                background: "#E0E0E0",
              },
              "&.Mui-selected:hover": {
                background: colors.primaryButtonOrangeHover,
              },
              "&:focus, &:active": {
                background: colors.primaryButtonOrange,
                border: `1px solid ${colors.primaryButtonOrange}`,
                color: "white",
              },
            },
          },
        },
      },
    },
    MuiStep: {
      styleOverrides: {
        alternativeLabel: {
          "&.MuiStep-alternativeLabel ": {
            " .MuiStepLabel-label": {
              "&.Mui-active": {
                color: Colors.primaryButtonOrange,
              },
              "&.Mui-completed": {
                color: Colors.primaryButtonOrange,
              },
              "&.Mui-disabled": {
                color: Colors.primaryButtonOrange,
              },
            },
          },
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {
          top: "16px",
          position: "relative",
          "& .MuiStepConnector-line": {
            border: "none",
            position: "relative",
            height: "2px",
            backgroundColor: "transparent",
            "&::before, &::after": {
              content: '""',
              position: "absolute",
              height: "2px",
              width: "100%",
              backgroundColor: Colors.primaryButtonOrangeDisabled,
              left: 0,
            },
            "&::before": {
              top: "10px",
            },
            "&::after": {
              top: "14px",
            },
          },
          "&.Mui-active .MuiStepConnector-line::before, &.Mui-active .MuiStepConnector-line::after":
            {
              backgroundColor: Colors.primaryButtonOrange,
            },
          "&.Mui-completed .MuiStepConnector-line::before, &.Mui-completed .MuiStepConnector-line::after":
            {
              backgroundColor: Colors.primaryButtonOrange,
            },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          "&.MuiTableContainer-root": {
            borderRadius: "6px",
            overflowX: "none",

            boxShadow: "none",
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "",
          color: "",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          "&.MuiTableCell-root": {
            padding: "11px",
            fontFamily: "Poppins, sans-serif",
          },
        },
      },
    },
  },
});
export default theme;
